<template>
    <div class="select_ent">
        <div class="content_wrapper">
            <div class="side_filters_select_container">
                <p>מציג {{ currentEntrepreneurs.length }} הצעות מיזמים ע"פ</p>
                <div class="filter">
                    <WzSelect v-model="filterSortBy" :settings="{ theme: 'light', width: '100%', height: '100%' }" :options="options" />
                </div>
                <nav class="ent_filter">
                    <div :class="{selected: currentStep === 'A'}" @click="handleStepClick('A')">כל היזמים</div>
                    <div :class="{selected: currentStep === 'B'}" @click="handleStepClick('B')">יזמים נבחרים</div>
                </nav>
                <ul class="entrepreneurs_con">
                    <li :class="{selected: selectedEntrepreneurId === ent.id}" @click="selectedEntrepreneurId = ent.id" class="entrepreneur" v-for="ent in currentEntrepreneurs" :key="ent.id">
                        <div class="grade_con">
                            <span v-text="ent.main_grade"></span>
                        </div>
                        <p class="company_name" v-text="ent.company_name"></p>
                    </li>
                </ul>
                <p style="font-size: 16px;">**הציון הוא מ 0-100</p>
            </div>
            <div class="yazam_data" v-if="selectedEnt">
                <div class="data_actions_container">
                    <div class="prj_data_container">
                        <div class="grade_name_con">
                            <div class="grade_con">
                                <span v-text="selectedEnt.main_grade"></span>
                            </div>
                            <div class="name_watch">
                                <p class="name" v-text="selectedEnt.company_name"></p>
                                <span class="watch" v-if="selectedEnt?.info" @click="$bus.$emit('open_yazamdata')">צפייה בפרטי היזם</span>
                              
                            </div>
                            
                        </div>
                        <a class="btn2" target="_blank" :href="selectedEnt?.pdf" v-if="selectedEnt?.pdf && selectedEnt?.pdf != ''">
                            <div class="icon download_icon"></div>תנאי עו"ד חתום</a>
                        <div class="filter" v-if="selectedEnt.contract.notAprouveClauseNum">
                            <div class="theme-switch-wrapper mid"> 
                                <label class="theme-switch" for="checkbox_1">
                                    <input v-model="selectedEnt.show_contract_not_aprouve" type="checkbox" id="checkbox_1" />
                                    <div class="slider round"></div>
                                </label>
                            </div>
                            <span>הצג רק את הסעיפים שהיזם לא אישר <strong v-text="'(' + selectedEnt.contract.notAprouveClauseNum + ')'"></strong></span>
                        </div>
                    </div>
                    <div class="btn_b text_s" v-text="selectedEntrepreneursIds.includes(selectedEnt.id) ? 'הסר מהשוואת יזמים' : 'הוסף להשוואת יזמים'" @click="handleSelectEnt"></div>
                </div>
                <nav class="type">
                    <div v-for="type in selectedContract.types" :key="type.id" :class="{selected: activeTypeId==type.id}" @click="activeTypeId=type.id">{{type.name}}</div>
                </nav>
                <div class="contracts" v-if="selectedContractType">
                    <contractPart 
                        @ratePart="ratePart" 
                        @addNotePopup="handleAddNotePopup($event, part)" 
                        :dontShowIfNotAprouve="selectedEnt.show_contract_not_aprouve" 
                        :showIsAprouve="true" 
                        :index="i" 
                        v-for="(part, i) in selectedContractType.parts" 
                        :key="part.id + '-' + selectedEnt.id" 
                        state="watch" 
                        mode="lawyer" 
                        @update="part = $event" 
                        @addClause="addClause($event, part.id)" 
                        :partComp="part"  
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import WzSelect from '@/components/wzselect.vue';
import contractPart from '@/components/applyingPrj/contractPart.vue';

export default {
    name: 'SelectEnt',
    components: { WzSelect, contractPart },
    props: {
        entrepreneurs: {
            type: Array,
            required: true
        },
        selectedEntrepreneursIds: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            filterSortBy: 'hight_to_low',
            selectedEntrepreneurId: null,
            activeTypeId: 'settings',
            currentStep: 'A',
            options: [
                { key: 'hight_to_low', val: "ציון מהגבוה לנמוך"},
                { key: 'low_to_hight', val: "ציון מהנמוך לגבוה"}
            ]
        }
    },
    watch: {
        entrepreneurs: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.length > 0 && !this.selectedEntrepreneurId) {
                    this.selectedEntrepreneurId = newVal[0].id;
                    this.activeTypeId = this.selectedContract.types?.[0]?.id;
                }
            }
        }
    },
    methods: {
        handleStepClick(step) {
            if (step === 'B' && this.selectedEntrepreneursIds.length === 0) {
                this.$emit('show-toast', 'יש לבחור לפחות יזם אחד להמשך', 'warning');
                return;
            }
            this.currentStep = step;
        },
        handleSelectEnt() {
            this.$emit('select-entrepreneur', this.selectedEnt.id);
        },
        ratePart(part) {
            this.$emit('rate-part', part);
        },
        handleAddNotePopup(clauseId, part) {
            const clause = this.findClauseById(clauseId, part);
            if (clause) {
                this.$emit('addNotePopup', clause);
            }
        },
        findClauseById(clauseId, part) {
            if (part.clauses) {
                for (const clause of part.clauses) {
                    if (clause.id === clauseId) {
                        return clause;
                    }
                }
            }
            return null;
        },
        filtereParts(parts, type) {
            return parts.filter(part => part.type === type);
        }
    },
    computed: {
        currentEntrepreneurs() {
            return this.currentStep === 'A' 
                ? this.entrepreneursComp 
                : this.entrepreneursComp.filter(ent => this.selectedEntrepreneursIds.includes(ent.id));
        },
        selectedEnt() {
            const selectedItem = this.entrepreneurs.filter(item => item.id === this.selectedEntrepreneurId);
            if (selectedItem.length > 0) {
                return selectedItem[0];
            }
            return null;
        },
        entrepreneursComp() {
            const sortedEntrepreneurs = this.entrepreneurs.slice();

            if (this.filterSortBy === 'hight_to_low') {
                return sortedEntrepreneurs.sort((a, b) => b.main_grade - a.main_grade);
            }
            if (this.filterSortBy === 'low_to_hight') {
                return sortedEntrepreneurs.sort((a, b) => a.main_grade - b.main_grade);
            }
            return sortedEntrepreneurs;
        },
        selectedContract() {
            return this.selectedEnt.contract ? this.selectedEnt.contract : null;
        },
        selectedContractType() {
            return this.selectedContract.types.find(type => type.id === this.activeTypeId);
        }
    }
}
</script>

<style lang="scss" scoped>
.btn2 { width: 100%;padding: 0 10px;color: var(--dark_blue); }
.btn2 {
    &{box-shadow: var(--box-shadow);min-height: 40px;border: solid 1px var(--text_s);border-radius: 12px;display: flex;justify-content: center;align-items: center;text-align: center;font-size: var(--h5);flex-basis: 27%;gap: 4px;}
    .icon {width: 24px;height: 24px;}
}
.select_ent { padding: var(--gap_xmid); display: flex; flex-direction: column; gap: var(--gap_mbig);
    @include mobile {
        padding: 8px 5px;
        gap: 10px;
        border-radius: 12px;
    }
    .content_wrapper { display: flex; gap: var(--gap_mbig);
        @include mobile {
            flex-direction: column;
            gap: 10px;
        }
        .side_filters_select_container { position: relative; width: 290px; display: flex; flex-direction: column; gap: var(--gap_small);
            @include mobile {
                width: 100%;
                gap: 8px;
                padding: 0 4px;
            }
            &::after { content: ''; position: absolute; inset-block: 0; width: 1px; background: var(--gray);left: calc( (var(--gap_mbig) / 2) * -1); 
                @include mobile {
                    display: none;
                }
            }
            nav.ent_filter { display: flex; justify-content: space-between; gap: var(--gap_sm);
                @include mobile {
                    gap: 4px;
                }
                div { flex: 1; text-align: center; cursor: pointer; padding: var(--gap_sm); border-radius: var(--radius); font-size: var(--h4); color: var(--dark_blue);
                    @include mobile {
                        font-size: 15px;
                        padding: 8px 0;
                    }
                    &.selected { background: var(--gray); }
                }
            }
            ul.entrepreneurs_con { display: flex; flex-direction: column; gap: 10px; 
                @include mobile {
                    gap: 6px;
                }
                li { cursor: pointer; border: 1px solid var(--pageBG); border-radius: var(--radius_m); display: flex; align-items: center; gap: var(--gap_sm); padding:  var(--gap_sm); 
                    @include mobile {
                        gap: 4px;
                        padding: 8px 4px;
                    }
                    &.selected { background: var(--gray); }
                    p { font-size: var(--h4); line-height: 1; color: var(--dark_blue);
                        @include mobile {
                            font-size: 16px;
                        }
                    }
                }
            }
            p[style] {
                @include mobile {
                    font-size: 12px !important;
                }
            }
        }
        .yazam_data { flex: 1; display: flex; flex-direction: column; gap: var(--gap_mid);
            @include mobile {
                gap: 8px;
                padding: 0 4px;
            }
            .data_actions_container { display: flex; justify-content: space-between; border-radius: var(--radius); padding: var(--gap_mid) var(--gap_xmid); border: 1px var(--pageBG) solid; 
                @include mobile {
                    flex-direction: column;
                    gap: 8px;
                    padding: 10px 6px;
                }
                .prj_data_container { display: flex; flex-direction: column; gap: var(--gap); 
                    @include mobile {
                        gap: 6px;
                    }
                    .grade_name_con { display: flex; align-items: center; gap: var(--gap_sm);
                        @include mobile {
                            gap: 4px;
                        }
                        .name_watch { display: flex; align-items: center; gap: var(--gap_sm);
                            @include mobile {
                                gap: 4px;
                            }
                            .name { position: relative; font-size: var(--h3); color: var(--dark_blue);
                                @include mobile {
                                    font-size: 22px;font-weight: 600;
                                }
                                &::after { content: ''; position: absolute; inset-block: 0; width: 1px; background: var(--gray);left: calc( (var(--gap_sm) / 2) * -1); }
                            }
                            span.watch { cursor: pointer; color: var(--color2); text-decoration: underline; font-weight: bold;
                                @include mobile {
                                    font-size: 13px;
                                }
                            }
                        }
                    }
                    .filter { display: flex; align-items: center; gap: var(--gap);
                        @include mobile {
                            gap: 4px;
                        }
                    }
                }
            }
            nav.type { display: flex; justify-content: space-around;
                @include mobile {
                    gap: 4px;
                }
                div { font-weight: 400; cursor: pointer; color: var(--dark_blue); font-size: var(--h3); 
                    @include mobile {
                        font-size: 16px;
                        padding: 6px 0;
                    }
                    &.selected { text-decoration: underline;}
                }
            }
            .contracts { display: flex; flex-direction: column; gap: var(--gap_mid);
                @include mobile {
                    gap: 6px;
                }
            }
        }
    }
}
</style> 